import { SolicitacaoVistoria } from "./SolicitacaoVistoria";

export default SolicitacaoVistoria;